// Shared constants for the Education Question Add/Edit forms.
//
// NOTE: `value` is the string persisted to / read from the backend
// (`question_type`). Do not change a `value` without a corresponding data
// migration — existing records rely on the exact string (including the
// historical "lickert scale" spelling). Only `label` is shown in the UI.
export const QUESTION_TYPES = [
  {
    value: 'multiple choice - single selection',
    label: 'multiple choice - single selection',
  },
  {
    value: 'multiple choice - multiple selection',
    label: 'multiple choice - multiple selection',
  },
  { value: 'open ended', label: 'open ended' },
  { value: 'rating question', label: 'rating question' },
  { value: 'lickert scale', label: 'Likert scale' },
];

export const PLATFORMS = [
  { value: 'whatsapp', label: 'Whatsapp' },
  { value: 'ussd', label: 'USSD' },
];

export const CATEGORIES = [
  'Organisation for Economic Co-operation and Development',
  'Custom',
];
